module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "logo"
  }, [_c('router-link', {
    attrs: {
      "to": _vm.linkHome
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/img/amol1.png")
    }
  })])], 1), _vm._v(" "), _c('ul', {
    staticClass: "menu"
  }, [_vm._m(0), _vm._v(" "), _c('li', {
    staticClass: "parent"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'askbox'
      },
      "active-class": "active",
      "exact": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.toggle($event)
      }
    }
  }, [_vm._v("\n                Solicitar BOX\n            ")])], 1), _vm._v(" "), _c('li', {
    staticClass: "parent"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'bidbox_internal'
      },
      "active-class": "active",
      "exact": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.toggle($event)
      }
    }
  }, [_vm._v("\n                Ofrecer BOX\n            ")])], 1), _vm._v(" "), _c('li', {
    staticClass: "parent"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'patientscoords'
      },
      "active-class": "active",
      "exact": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.toggle($event)
      }
    }
  }, [_vm._v("\n                Pacientes\n            ")])], 1), _vm._v(" "), _vm._l((_vm.options), function(option, index) {
    return _c('li', {
      key: option.id,
      staticClass: "parent"
    }, [(!option.submenu && option.visible) ? _c('router-link', {
      attrs: {
        "active-class": "active",
        "exact": "",
        "to": {
          path: _vm.linkOption(option)
        }
      },
      nativeOn: {
        "click": function($event) {
          _vm.toggle($event)
        }
      }
    }, [_vm._v(_vm._s(option.name) + "\n            ")]) : (option.submenu && option.visible) ? _c('a', {
      staticClass: "dropdown",
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          _vm.open(index, option.perms.length)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(option.name))]), _vm._v(" "), _c('span', {
      staticClass: "icon_caret"
    }, [_c('i', {
      staticClass: "md-icon md-list-expand-indicator md-theme-default material-icons",
      attrs: {
        "aria-hidden": "true"
      }
    }, [_vm._v("keyboard_arrow_right")])])]) : _vm._e(), _vm._v(" "), (option.submenu && option.perms) ? _c('ul', {
      staticClass: "submenu"
    }, _vm._l((option.perms), function(submenu, index) {
      return (_vm.showSubMenu(submenu)) ? _c('li', {
        key: index
      }, [_c('router-link', {
        attrs: {
          "to": {
            path: _vm.linkOptionSubMenu(submenu)
          },
          "active-class": "active",
          "exact": ""
        },
        nativeOn: {
          "click": function($event) {
            _vm.toggle($event)
          }
        }
      }, [_vm._v("\n                        " + _vm._s(submenu.display_name) + "\n                    ")])], 1) : _vm._e()
    })) : _vm._e()], 1)
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "language"
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('md-icon', [_vm._v("language")])], 1), _vm._v(" "), _c('md-select', {
    attrs: {
      "name": "language",
      "id": "language"
    },
    on: {
      "change": _vm.updateLang
    },
    model: {
      value: (_vm.lang),
      callback: function($$v) {
        _vm.lang = $$v
      },
      expression: "lang"
    }
  }, _vm._l((_vm.languages), function(language) {
    return _c('md-option', {
      key: language.id,
      attrs: {
        "value": language.code
      }
    }, [_vm._v(_vm._s(language.name))])
  }))], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "parent"
  }, [_c('a', {
    attrs: {
      "href": "https://tienda.agendaenlinea.cl/",
      "target": "_blank"
    }
  }, [_vm._v("Pago en Linea")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cd899af4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/doctor/partials/Sidebar.vue
// module id = 692
// module chunks = 1